import './index.scss'
import ObjectManager from '../../../utils/object'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import Checkbox from '../checkbox'
import {SortIcon} from '../../../icons'
import {colors} from '../../../utils/colors'
import localStorageKeys from '../../../utils/localStorageKeys'
import localStorageManager from '../../../utils/localStorageManager'
import {sortBySelected} from '../../../utils/sorting'
import {useEffect, useState} from 'react'

const Table = ({
    tableHeader,
    data,
    tbodyData,
    hasCheckbox,
    isMultiCheckable,
    identificator,
    inputName,
    isScrollable,
    setSelectedData,
    selectedData,
    strech,
    isSortingEnabled,
    setData,
    sortId,
    filteredData,
    ...props
}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    let currentSortOptions = localStorageManager.get(localStorageKeys.SORT_OPTIONS) || {}
    const [selectedSortOption, setSelectedSortOption] = useState(null)

    const checkAllData = () => {
        const newSelectedData = [...selectedData]
        if (data?.length === selectedData.length) {
            setSelectedData([])
            return
        }
        data.forEach(item => {
            !selectedData.includes(item?.[identificator]) && newSelectedData.push(item?.[identificator])
        })
        setSelectedData(newSelectedData)
    }

    const deletelocalSelectedData = id => {
        setSelectedData(ObjectManager.delete(selectedData, '', id))
    }

    const singleCheck = id => {
        if (selectedData.includes(id)) {
            deletelocalSelectedData(id)
            return
        }
        setSelectedData([id])
    }

    const checkItem = id => {
        if (!isMultiCheckable) {
            singleCheck(id)
            return
        }
        let newSelectedData = [...selectedData]
        if (selectedData.includes(id)) {
            deletelocalSelectedData(id)
            return
        }
        newSelectedData.push(id)
        setSelectedData(newSelectedData)
    }
    const getAllCheckStatus = () => {
        return data?.length === selectedData?.length && data.every(item => selectedData?.includes(item?.[identificator]))
    }

    const toggleSortOption = (index) => {
        const ascKey = tableHeader?.[index]?.sorting?.asc?.key
        const descKey = tableHeader?.[index]?.sorting?.desc?.key

        if (selectedSortOption === ascKey) {
            setSelectedSortOption(descKey)
            currentSortOptions[sortId] = descKey
            localStorageManager.set(localStorageKeys.SORT_OPTIONS, currentSortOptions)
            return
        }

        if (selectedSortOption === descKey) {
            setSelectedSortOption(null)
            delete currentSortOptions[sortId]
            setData(filteredData || props?.originalData)
            localStorageManager.set(localStorageKeys.SORT_OPTIONS, currentSortOptions)
            return
        }

        setSelectedSortOption(ascKey)
        currentSortOptions[sortId] = ascKey
        localStorageManager.set(localStorageKeys.SORT_OPTIONS, currentSortOptions)
    }

    useEffect(() => {
        setSelectedSortOption(currentSortOptions?.[sortId])
    }, [])

    useEffect(() => {
        if (!isSortingEnabled) return

        props?.callbackFn ?
            props.callbackFn() :
            setData(sortBySelected(data, sortId, tableHeader, props?.customFieldLogic))
    }, [selectedSortOption])

    const isSortingActive = (sorting) => selectedSortOption === sorting.desc?.key || selectedSortOption === sorting?.asc.key

    return (
        <div className={classNames({
            'table-container': true,
            'dark': isDarkMode,
            strech
        })}>
            <table>
                <thead className={classNames({
                    'dark': isDarkMode
                })}>
                    <tr className={classNames({
                        'dark': isDarkMode
                    })}>
                        {hasCheckbox &&
                        (
                            <th className={`checkbox-field ${!isMultiCheckable ? 'hidden' : ''}`}>
                                {data?.length > 0 && (

                                    <Checkbox  type="checkbox" onChange={checkAllData} checked={getAllCheckStatus()} id="header-checkbox"/>
                                )}
                            </th>
                        )
                        }
                        {tableHeader?.map((item, index) => {
                            const {label} = item
                            return (
                                <th key={index} className={classNames('data-th', {
                                    'dark': isDarkMode
                                })}>
                                    <span className={classNames({
                                        [item?.className]: !!item?.className
                                    })}>
                                        <span className={classNames('text', {
                                            'dark': isDarkMode
                                        })}>
                                            {label}
                                        </span>
                                        {item?.sorting && (
                                            <span className={classNames('sort-btn', {
                                                'desc': selectedSortOption === item?.sorting?.desc?.key,
                                                'active': isSortingActive(item?.sorting)
                                            })} onClick={() => toggleSortOption(index)}>
                                                <SortIcon
                                                    className="sort-icon"
                                                    stroke={isDarkMode ? colors.colorFilterTitle : colors.colorMuted}
                                                    fill={isSortingActive(item?.sorting) ? (isDarkMode ? colors.colorFilterTitle : colors.colorMuted) : 'none'}
                                                />
                                            </span>
                                        )}

                                    </span>
                                </th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody className={classNames({
                    'dark': isDarkMode,
                    'scrolllable': isScrollable
                })}>
                    {data?.map((item, index) => {
                        return (
                            <tr key={item?.[identificator] || index}
                                className={classNames({
                                    'checked': selectedData?.includes(item?.[identificator]),
                                    'dark': isDarkMode
                                })}>
                                {hasCheckbox &&
                                (
                                    <td className={classNames('checkbox-field', {
                                        'dark': isDarkMode
                                    })}>

                                        <Checkbox  type="checkbox" onChange={() => checkItem(item?.[identificator])} checked={selectedData?.includes(item?.[identificator])} name={inputName}/>
                                    </td>
                                )
                                }
                                {tbodyData[index]?.map((item, i) => {
                                    return (
                                        <td key={i} className="data-td">
                                            <span className={classNames('text', {
                                                'dark': isDarkMode
                                            })}>
                                                {item}
                                            </span>
                                        </td>
                                    )
                                }
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default Table
